import { inject } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { DocumentsFromVetService, LoginService } from '@pxl/models/contracts';
import {
    DocumentsFromVeterinarianPackageModel,
    DocumentsFromVeterinarianService,
    DocumentsfromveterinarianSigneddocumentBody,
    DocumentsFromVeterinarianToFillQuestionModel,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

export class DefaultDocumentsFromVetService implements DocumentsFromVetService {
    protected readonly documentsFromVetService = inject(DocumentsFromVeterinarianService);
    protected readonly loginService = inject(LoginService);
    protected readonly apiVersion = inject(CONFIG_TOKEN).API_VERSION;

    protected get token() {
        return this.loginService.getToken();
    }

    public getDocumentPackages(includeHidden = false): Observable<DocumentsFromVeterinarianPackageModel[]> {
        return this.documentsFromVetService.get(this.apiVersion, this.token, includeHidden);
    }

    public getDocumentPackageById(packageId: string): Observable<DocumentsFromVeterinarianPackageModel> {
        return this.documentsFromVetService.getById(packageId, this.apiVersion, this.token);
    }

    public updateQuestions(documentId: string, documentModels: DocumentsFromVeterinarianToFillQuestionModel[]): Observable<void> {
        return this.documentsFromVetService.updateQuestions(documentModels, this.apiVersion, this.token, documentId);
    }

    public saveSignedDocument(documentsFromVeterinarianToSignId: string, signedDocumentAsByte64: string): Observable<void> {
        const documentsfromveterinarianSigneddocumentBody: DocumentsfromveterinarianSigneddocumentBody = {
            signedDocumentAsByte64,
            documentsFromVeterinarianToSignId,
        };
        return this.documentsFromVetService.saveSignedDocument(documentsfromveterinarianSigneddocumentBody, this.apiVersion, this.token);
    }

    public sendDocumentToVet(documentId: string): Observable<void> {
        return this.documentsFromVetService.send(documentId, this.apiVersion, this.token);
    }

    public markAsHidden(documentsFromVeterinarianPackageId: string): Observable<void> {
        return this.documentsFromVetService.markAsHidden(documentsFromVeterinarianPackageId, this.apiVersion, this.token, true);
    }

    public markAsVisible(documentsFromVeterinarianPackageId: string): Observable<void> {
        return this.documentsFromVetService.markAsHidden(documentsFromVeterinarianPackageId, this.apiVersion, this.token, false);
    }

    public toggleNotifications(documentsFromVeterinarianPackageId: string, disableReminder: boolean): Observable<void> {
        return this.documentsFromVetService.disableReminders(
            documentsFromVeterinarianPackageId,
            this.apiVersion,
            this.token,
            disableReminder,
        );
    }
}
